module.exports = __webpack_public_path__ + "media/images/fallback/product_small_thumb-14aaeec166748bb879df028f50df83ce.webp";